import React from 'react';
import {NavLink, useLocation} from 'react-router-dom';
import {useUserRoutes} from "../../../Routing.jsx";

function groupRoutes(routes, pathname) {

    let groups = {};

    for (let route of routes) {
        groups[route['group']] = {
            name: route['group'],
            routes: [],
        };
    }

    for (let route of routes) {
        route['is_current'] = (route['path'] === pathname);
        groups[route['group']]['routes'].push(route);
    }

    return groups;
}

function UserSettingsLayoutMenu() {

    const location = useLocation();
    const {pathname} = location;

    const [userRoutes] = useUserRoutes();
    const groupedUserRoutes = groupRoutes(userRoutes, pathname);

    return (
        <div
            className="flex flex-nowrap overflow-x-scroll no-scrollbar md:block md:overflow-auto px-3 py-6 border-b md:border-b-0 md:border-r border-slate-200 dark:border-slate-700 min-w-[12rem] md:space-y-3">
            {Object.values(groupedUserRoutes).map((group) => {
                return (
                    <div key={group['name'].toString()}>
                        <div className="text-xs font-semibold text-slate-400 dark:text-slate-500 uppercase mb-3">
                            {group['name']}
                        </div>
                        <ul className="flex flex-nowrap md:block mr-3 md:mr-0">
                            {group['routes'].map((route) => {
                                return (
                                    <li className="mr-0.5 md:mr-0 md:mb-0.5" key={route['name'].toString()}>
                                        <NavLink end to={route['path'].toString()}
                                                 className={`flex items-center px-2.5 py-2 rounded whitespace-nowrap ${route['is_current'] && 'bg-indigo-50 dark:bg-indigo-500/30'}`}>

                                            <span className={
                                                `pr-2
                                                ${
                                                    route['is_current']
                                                        ? 'text-indigo-500 dark:text-indigo-400'
                                                        : 'text-slate-600 dark:text-slate-300 hover:text-slate-700 dark:hover:text-slate-200'
                                                }
                                            `}>
                                                {route['icon']}
                                            </span>
                                            <span className={
                                                `text-sm font-medium 
                                                ${
                                                    route['is_current']
                                                        ? 'text-indigo-500 dark:text-indigo-400'
                                                        : 'text-slate-600 dark:text-slate-300 hover:text-slate-700 dark:hover:text-slate-200'
                                                }
                                            `}>
                                                {route['name']}
                                            </span>
                                        </NavLink>
                                    </li>
                                );
                            })}
                        </ul>
                    </div>
                );
            })}
        </div>
    );
}

export default UserSettingsLayoutMenu;